import React from "react";
import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { featureFlagAPi, logUserAction } from "./components/apiCall";
import { setFeatureflag, setToaster } from "./redux/actions/index";
import Dashboard from "./pages/Dashboard";
import { Routes, Route, useLocation } from "react-router-dom";
import SearchResultPage from "./pages/SearchResultPage";
import SearchResultDetailPage from "./pages/SearchResultDetailPage";
import AllPinnedSearchPage from "./pages/AllPinnedSearchPage";
import Toaster from "./components/Toaster/Toaster";
import Banner from "./components/Banner/BannerPop";
import { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent, previewPageGA } from "./googleAnalytics/Analytics";
import KeycloakUserService from "./keycloak/KeycloakUserService";
import { trackLogin, trackLogout, trackSessionDuration, trackPageView } from "./utils/posthog";


function App(props) {
  const location = useLocation();
  const sessionStartRef = useRef(Date.now());

  const [showBanner, setShowBanner] = useState(false);
  const handleSetShowBanner = (show) => {
    setShowBanner(show);
    localStorage.setItem('bannerClosed', (!show).toString());
  };
  useEffect(() => {
    // PostHog: identify user FIRST — must happen before any early returns
    const userId = KeycloakUserService.getUserID();
    const token = KeycloakUserService.getTokenParsed?.();
    if (userId && token) {
      const traits = {
        username:       token.preferred_username  || '',
        email:          token.email               || '',
        name:           token.name                || '',
        given_name:     token.given_name          || '',
        family_name:    token.family_name         || '',
        email_verified: token.email_verified      ?? false,
        roles:          token.realm_access?.roles || [],
      };
      console.log(`[PostHog] Identifying user: ${userId}, traits:`, traits);
      trackLogin(userId, traits, 'keycloak');
    }

    const bannerShownTimestamp = localStorage.getItem('bannerShownTimestamp');
    const bannerClosed = localStorage.getItem('bannerClosed') === 'true';
    const sevenDaysInMilliseconds = 14 * 24 * 60 * 60 * 1000;
    const now = new Date().getTime();
    
    if (bannerClosed) {
      setShowBanner(false);
      logUserAction({ route: 'login' });
      return;
    }

    if (bannerShownTimestamp) {
      const timeDiff = now - parseInt(bannerShownTimestamp, 10);
      if (timeDiff < sevenDaysInMilliseconds) {
        setShowBanner(true);
      } else {
        setShowBanner(false);
        localStorage.removeItem('bannerShownTimestamp');
      }
    } else {
        setShowBanner(true);
        localStorage.setItem('bannerShownTimestamp', now.toString());
    }

    logUserAction({
      route: 'login',
    });
  }, []);

  
  useEffect(() => {
    const handleBeforeUnload = () => {
      logUserAction({
        route: 'logout',
      });
      // PostHog: track session duration and logout
      const sessionDurationSeconds = Math.round((Date.now() - sessionStartRef.current) / 1000);
      trackSessionDuration(sessionDurationSeconds);
      trackLogout(sessionDurationSeconds);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    InitializeGoogleAnalytics();
    TrackGoogleAnalyticsEvent( 'Signed in with user ID', 'sampleAction' );
    // Fetch fature list to be enabled / disabled
    featureFlagAPi()
      .then((data) => {
        let featureObj = {};
        for (let i = 0; i < data.data.features.length; i++) {
          featureObj[data.data.features[i].featureId] =
            data.data.features[i].state === "enabled" ? true : false;
        }
        props.setFeatureflag(featureObj);
      })
      .catch(() => {
        props.setToaster(true);
      });
  }, []);

  useEffect(() => {
    console.log('Current Path:', location.pathname);
    previewPageGA(location.pathname);
    // PostHog: manual page view tracking on route changes
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <div className="z-0 app">
      <Banner showBanner={showBanner} setShowBanner={handleSetShowBanner} />
      {props.toaster && <Toaster />}
      <Routes>
        {/* home page route  */}
        <Route exact path="/" element={<Dashboard />}></Route>

        {/* search result page route here search result is shown  */}
        <Route
          exact
          path="/searchResult"
          element={<SearchResultPage />}
        ></Route>
        {/* search result detail page route here detail of search will be shown  */}
        <Route
          exact
          
          path="/searchResultDetail/:type/:id"
          element={<SearchResultDetailPage />}
        ></Route>

        {/* view all pinned searches */}
        <Route
          exact
          path="/allpinnedsearches"
          element={
            <div>
              <AllPinnedSearchPage />
            </div>
          }
        />
        {/* at this route all items will be shown  */}
        
      </Routes>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    toaster: state.toaster,
  };
};

export default connect(mapStateToProps, {
  setFeatureflag,
  setToaster,
})(App);